import { apiClient } from './apiClient';

export class ChatQuestionsService {
    constructor() {
        this.BASE_URL = '/chatQuestions';
    }

    async getAllChatQuestionsREST() {
        return apiClient.get(`${this.BASE_URL}`);
    }

    async getQuestionsByCategoryREST(category) {
        return apiClient.get(`${this.BASE_URL}/category/${category}`);
    }

    async updateQuestionREST(payload) {
        return apiClient.put(`${this.BASE_URL}`, payload);
    }

    async addCategoryREST(payload) {
        return apiClient.post(`${this.BASE_URL}`, payload);
    }

    async deleteCategoryREST(id) {
        return apiClient.delete(`${this.BASE_URL}/${id}`);
    }
}

export const chatQuestionsService = new ChatQuestionsService();